import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { format, eachDayOfInterval, isToday } from "date-fns";
import { ChevronLeft, ChevronRight } from "styled-icons/boxicons-regular";
import { Row, Col } from "styled-bootstrap-grid";
import styled from "styled-components";
import ProfilePic from "../../Header/profile-pic-header.png";
import ClickOutside from "react-simple-click-outside";
import ShiftAllocation from "./ShiftAllocation";
import { withTranslation, Trans } from "react-i18next";
import { resetScheduleHoursMessage } from "../../../../Actions";
class ScheduledHours extends Component {
  constructor(props) {
    super(props);
    this.state = {
      weekStart: undefined,
      weekEnd: undefined,
      weekDataValues: undefined,
      formDataOpen: false,
      employeeData: undefined,
      otherData: "",
      heightSet: 0,
    };
    this.days = [];
    this.weekContainer = this.weekContainer.bind(this);
    this.openForm = this.openForm.bind(this);
    this.cancelForm = this.cancelForm.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  _close = () => {
    this.setState({
      standbyCss: { display: "none" },
    });
  };
  openForm(data, dayData) {
    this.setState((state) => ({
      formDataOpen: true,
      employeeData: data,
      otherData: dayData,
    }));
  }
  openEditForm = () => {
    return (
      <ShiftAllocation
        onClose={this.cancelForm}
        employeeDetails={this.state.employeeData}
        otherData={this.state.otherData}
      />
    );
  };
  cancelForm() {
    this.setState((state) => ({
      formDataOpen: false,
      employeeData: undefined,
    }));
  }
  componentDidMount() {
    this.setState({
      weekDataValues: this.props.weekData,
      weekStart: this.props.startDate,
      weekEnd: this.props.endDate,
    });
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
  }
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        weekDataValues: this.props.weekData,
        weekStart: this.props.startDate,
        weekEnd: this.props.endDate,
      });

      if (this.props.scheduleHoursMessage.errorCd === "SUCCESS") {
        this.props.updateData();
        this.props.resetScheduleHoursMessage();
      }
      this.updateDimensions();
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
    this.setState({ heightSet: document.body.scrollHeight });
  }
  weekView = () => {
    const { formDataOpen } = this.state;
    return (
      <ParentDiv>
        <ButtonLeft
          disabled={formDataOpen}
          type="submit"
          onClick={() => {
            this.props.weekAction("previous");
          }}
        >
          {" "}
          <Caretleft size="24" />
        </ButtonLeft>
        <span>
          {format(this.state.weekStart, "dd")}{" "}
          <Trans>{format(this.state.weekStart, "MMM").toLowerCase()}</Trans> -{" "}
          {format(this.state.weekEnd, "dd")}{" "}
          <Trans>{format(this.state.weekEnd, "MMM").toLowerCase()}</Trans>{" "}
          {format(this.state.weekEnd, "yyyy")}
          {/* {format(this.state.weekStart, "dd MMM")} -{" "}
          {format(this.state.weekEnd, "dd MMM yyyy")} */}
        </span>
        <ButtonRight
          disabled={formDataOpen}
          type="submit"
          onClick={() => {
            this.props.weekAction("next");
          }}
        >
          <Caretright size="24" />
        </ButtonRight>
        <MainApp>{this.weekContainer()}</MainApp>
      </ParentDiv>
    );
  };

  weekContainer() {
    var start = this.state.weekStart;
    var end = this.state.weekEnd;
    var array = eachDayOfInterval({ start, end });
    var isWeekData = true;
    const { formDataOpen } = this.state;
    var updatedHt = this.state.heightSet - 288;
    const empDivStyle = {
      maxHeight: updatedHt + "px",
    };
    return (
      <>
        <WeekdaysDiv>
          <RowMain>
            <EmployeeCol md="2" />
            {array.map((days) => (
              <WeekDaysName key={days}>
                <ColInner sm="1">
                  <WeekDays>
                    <WeekDate value={isToday(days)}>
                      {format(days, "dd")}{" "}
                    </WeekDate>
                    <Trans>{format(days, "eee").toLowerCase()}</Trans>{" "}
                    {/* {format(days, "eee")}{" "} */}
                  </WeekDays>
                </ColInner>
              </WeekDaysName>
            ))}
          </RowMain>
          <ClickOutside close={this._close} target="hidden">
            <AllEmployeeDataDiv style={empDivStyle}>
              {this.state.weekDataValues.employeeDetails.map(
                (employeeData, index) => (
                  <RowMainDiv key={employeeData.ssoId}>
                    <EmployeeCol md="2">
                      <EmployeeNameDiv
                        onClick={() => {
                          console.log("Inside on clicked Scheduled hours props", this.props);
                          console.log("Inside on clicked Scheduled hours props history", this.props.history);
                          this.props.history.push(
                            employeeData.ssoId + "/techniciandetails"
                          )

                        }
                        }
                      >
                        <img src={ProfilePic} alt="profilepic" />
                        <span>
                          {employeeData.firstName} {"  "}{" "}
                          {employeeData.lastName}
                        </span>
                      </EmployeeNameDiv>
                    </EmployeeCol>
                    {isWeekData
                      ? employeeData.otherDetails.map((othersData, i) => {
                          let uniqueIndex =
                            employeeData.otherDetails.length * index + i;
                          return (
                            <EmployeeDataDiv
                              Approved={othersData.isApproved}
                              Absent={othersData.isAbsent}
                              key={uniqueIndex}
                              ref={(ref) => (this.days[uniqueIndex] = ref)}
                              onClick={() => {
                                this.openForm(employeeData, othersData);
                              }}
                            >
                              {othersData.scheduledHours}
                            </EmployeeDataDiv>
                          );
                        })
                      : array.map((days, i) => {
                          let uniqueIndex =
                            employeeData.otherDetails.length * index + i;
                          return (
                            <EmployeeDataDiv
                              key={format(days, "MM/dd/yyyy")}
                              ref={(ref) => (this.days[uniqueIndex] = ref)}
                            />
                          );
                        })}
                  </RowMainDiv>
                )
              )}
            </AllEmployeeDataDiv>
          </ClickOutside>
        </WeekdaysDiv>
        <FooterData formDataOpen={formDataOpen} heightData={updatedHt}>
          {!formDataOpen ? (
            <p>
              <Button onClick={this.props.BackTab}>
                <Trans>back</Trans>
              </Button>
            </p>
          ) : (
            this.openEditForm()
          )}
        </FooterData>
      </>
    );
  }

  render() {
    return (
      <>{this.state.weekDataValues !== void 0 ? this.weekView() : <div />}</>
    );
  }
}

const mapStateToProps = ({
  auth,
  userMessage,
  managerTimesheetData,
  scheduleHours,
}) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    userDefault: auth.user.defaultProfile,
    weekData: managerTimesheetData.payload.weekDataDetails,
    scheduleHoursMessage: scheduleHours.message,
    shiftData: managerTimesheetData.payload.shiftList,
  };
};

const mapDispatchToProps = (dispatch) => ({
  resetScheduleHoursMessage: () => {
    dispatch(resetScheduleHoursMessage());
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ScheduledHours))
);

const MainApp = styled.div`
  position: relative;
  height: 100vh;
`;
const WeekdaysDiv = styled.div`
  position: relative;
  top: 23px;
  font-family: Trebuchet MS;
  width: 100%;
  text-align: center;
`;
const WeekDaysName = styled.div`
  position: relative;
  min-height: 1px;
  display: inline-table;
  width: 10%;
  padding: 5px 0;
`;
const WeekDate = styled.div`
  background: ${(props) => (props.value ? "#70b0f3" : "#FFFFFF")};
  color: ${(props) => (props.value ? "#FFFFFF" : "#000000")};
  margin-right: 10px;
  top: 1px;
  border-radius: 20px;
  height: 20px;
  width: 20px;
  padding-right: 1px;
  padding-top: 1px;
`;
const WeekDays = styled.div`
  display: flex;
  position: relative;
`;
const EmployeeDataDiv = styled.div`
  min-height: 1px;
  color: ${(props) => (props.Approved === "Y" ? "#7e7e7e" : "#000000")};
  pointer-events: ${(props) => (props.Approved === "Y" ? "none" : "")};
  display: flex;
  width: 10%;
  text-align: justify;
  border: 1px solid #e8e8e8;
  background: #ffffff;
  cursor: pointer;
  text-align: center;
  justify-content: center;
  padding-top: 15px;
  position: relative;
`;
const Caretleft = styled(ChevronLeft)`
  position: relative;
  right: 8px;
  bottom: 4px;
  background: #b7b7b7;
  border-radius: 20px;
`;
const Caretright = styled(ChevronRight)`
  position: relative;
  right: 8px;
  bottom: 4px;
  background: #b7b7b7;
  border-radius: 20px;
`;
const ButtonLeft = styled.button`
  position: relative;
  right: 17px;
  top: 2px;
  border-radius: 20px;
  height: 24px;
  width: 24px;
`;
const ButtonRight = styled.button`
  position: relative;
  left: 17px;
  top: 2px;
  border-radius: 20px;
  height: 24px;
  width: 24px;
`;
const RowMain = styled(Row)`
  margin-right: 0px;
  margin-left: 0px;
  font-size: 14px;
`;
const RowMainDiv = styled(Row)`
  margin: 0px;
  height: 57px;
`;
const EmployeeNameDiv = styled.div`
  top: 60%;
  left: 40%;
  color: #4a4a4a;
  font-size: 16px;
  cursor: pointer;
  && span {
    margin-left: 10px;
  }
`;
const EmployeeCol = styled(Col)`
  padding-top: 10px;
  padding-left: 0px;
  padding-right: 0px;
  width: 16%;
  margin-left: 7%;
`;
const ColInner = styled(Col)`
  position: relative;
  min-height: 1px;
  display: flex;
`;
const ParentDiv = styled.div`
  padding-top: 3px;
  font-size: 16px;
  width: 100%;
  text-align: center;
`;
const Button = styled.button`
  background: #ffffff;
  border-radius: 30px;
  padding: 0;
  border: 1px solid #96989a;
  height: 34px;
  width: 129px;
  position: relative;
  left: 8px;
  color: #000000;
  border: 1px solid #95989a;
  font-size: 12px;
`;
const FooterData = styled.div`
  border-top: 1px solid #babec3;
  background: #f1f4f9;
  height: 70px;
  padding-top: 15px;
  text-align: center;
  position: fixed;
  bottom: 0;
  right: 0px;
  width: 101%;
  margin-left: 4px;
  && p {
    bottom: 0px;
    position: absolute;
    width: 100%;
  }
  ${({ formDataOpen, heightData }) =>
    formDataOpen &&
    `
    position:fixed
    height: auto;
bottom:0;
  `}
`;
const AllEmployeeDataDiv = styled.div`
  text-align:left
  overflow-y: scroll;
//`;
